import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingTemplatePresetsQueryKey } from './get-campaign-templates';

export const DELETE_CAMPAIGN_TEMPLATE = 'api/marketing-template/delete-template-preset';

type DeleteCampaignTemplatePayload = {
  MarketingTemplatePresetId: number;
};

type DeleteCampaignTemplateResponse = {
  Message?: string;
  Success: boolean;
};

export function useDeleteCampaignTemplateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (marketingTemplatePresetId: number) => {
      const payload: DeleteCampaignTemplatePayload = {
        MarketingTemplatePresetId: marketingTemplatePresetId,
      };

      const res = await postData<DeleteCampaignTemplatePayload, DeleteCampaignTemplateResponse>({
        endpoint: DELETE_CAMPAIGN_TEMPLATE,
        payload,
      });

      return res;
    },
    onSuccess: () => {
      // Invalidate the templates list query to refresh the data
      void queryClient.invalidateQueries(marketingTemplatePresetsQueryKey);
    },
  });
}
